import styled from 'styled-components';

import { TransparentButton } from '@libs/components';

export const NavItemsWrapper = styled.div`
  display: flex;

  align-items: flex-start;
  padding: 1.2rem 1.6rem;
  justify-content: space-between;

  gap: 0.8rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
`;

export const NavItemTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 0.4rem;
  min-height: 3rem;
  line-height: 1.8;
`;

export const NavItemIconWrapper = styled.div`
  width: 6rem;
  height: 5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 0.1rem solid ${({ theme }) => theme.colors.interactive.secondary};
  background-color: ${({ theme }) => theme.colors.surface.buttonBackground};
  border-radius: ${({ theme }) => theme.borderRadius.x14};
`;

export const NavItemWrapper = styled(TransparentButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 8rem;
  position: relative;
  text-align: center;

  &:hover {
    ${NavItemIconWrapper} {
      opacity: 0.5;
    }
  }
  ${({ theme }) => theme.media.laptop`
    &:hover { 

     ${NavItemIconWrapper as unknown as TemplateStringsArray} {
      opacity: 1;

      border: 0.1rem solid ${
        theme.colors.interactive.brandColor as unknown as TemplateStringsArray
      };
      background-color: ${
        theme.colors.interactive.brandColor as unknown as TemplateStringsArray
      };
      .operationIcon {
        path {
          fill: ${
            theme.colors.text.interactive as unknown as TemplateStringsArray
          };
        }
      }
    }
  }
      padding: 2rem 0;
      
`};
`;
